import { FC } from 'react';

import { Flex, FlexProps, Typography } from 'antd';

import { IOffer } from 'entities/Offer/model/types';
import { useMedia, useTrans } from 'shared/hooks';

import { OfferTags } from '../OfferTags/OfferTags';

interface IOfferTitleProps extends Omit<FlexProps, 'children'> {
	offer: IOffer;
	isMyOffers?: boolean;
	isDashboard?: boolean;
}

export const OfferTitle: FC<IOfferTitleProps> = ({ offer, isMyOffers, isDashboard, ...props }) => {
	const isMd = useMedia();
	const { categories } = useTrans();
	const isSmall = isMd || isDashboard;

	return (
		<Flex {...props} vertical={isSmall} align="start" gap={isSmall ? 12 : 16} style={{ flexGrow: 1 }}>
			{(isMyOffers || isDashboard) && <img src={offer.image} alt={offer.name} width={80} style={{ minWidth: 80 }} />}

			<Flex vertical={isSmall} align="start" gap={isSmall ? 12 : 16} style={{ flexGrow: 1 }}>
				<Flex vertical gap={4} style={{ width: isSmall ? '100%' : '40%', minWidth: isSmall ? '100%' : '40%' }}>
					<Typography.Text strong style={{ lineHeight: '22px', minWidth: 80 }}>
						{offer.name}
					</Typography.Text>
					<Typography.Text type="secondary" style={{ lineHeight: '22px', fontSize: 12 }}>
						{offer.categories.map(({ slug }) => categories[slug]).join(', ')}
					</Typography.Text>
				</Flex>

				<OfferTags tags={offer.tags} />
			</Flex>
		</Flex>
	);
};
